import { render, staticRenderFns } from "./SplitPanel.vue?vue&type=template&id=b01243f6&scoped=true&"
import script from "./SplitPanel.vue?vue&type=script&lang=js&"
export * from "./SplitPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01243f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b01243f6')) {
      api.createRecord('b01243f6', component.options)
    } else {
      api.reload('b01243f6', component.options)
    }
    module.hot.accept("./SplitPanel.vue?vue&type=template&id=b01243f6&scoped=true&", function () {
      api.rerender('b01243f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/SplitPanel.vue"
export default component.exports